export function getTopCardsForSectionType(state, sectionType, top) {
  const sectionCards = state.cards ? state.cards[sectionType] : [];
  if (sectionCards && sectionCards.length > 0) {
    return sectionCards.slice(0, top);
  } else {
    return [];
  }
}
